import lottie from 'lottie-web/build/player/lottie_light'
import { useEffect, useRef } from 'react'
import { jsx } from "react/jsx-runtime"

export function LottieAnimation(props) {
  const ref = useRef(null)
  const { loop, autoplay, animationData, ...divProps } = props

  useEffect(() => {
    if (!ref.current) return

    const anim = lottie.loadAnimation({
      animationData,
      container: ref.current,
      renderer: 'svg',
      loop,
      autoplay,
    })

    return () => anim.destroy()
  }, [loop, autoplay, animationData])

  return jsx('div', { ref, ...divProps })
}

export function createLottieAnimation(animationData) {
  return function LottiePlayer(props) {
    return jsx(LottieAnimation, { ...props, animationData })
  }
}
